@if (isLoading) {
  <div id="loader" class="loader-container">
    <div class="loader"></div>
  </div>
}
